import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { useCobaltIntelligence, useCheckVoSosData } from '../hooks';

interface Props {
  voId: string;
  tooltip: string;
  disabled: boolean;
}

export const GenerateReportBtn = ({ voId, tooltip, disabled }: Props) => {
  const { isPulling, handlePullReport } = useCobaltIntelligence();
  const { hasData, missingData, isCheckLoading } = useCheckVoSosData(voId);

  const isSosDataMissing = !hasData;
  const isDisabled = disabled || isSosDataMissing || isCheckLoading;

  const resolvedTooltip = isSosDataMissing ? `Missing required VO data: ${missingData}` : tooltip;

  const handleClick = async () => {
    await handlePullReport({ voId, isMock: false }, api => ({
      awaitRefetchQueries: true,
      refetchQueries: [api.getLastSecretaryOfStateReportForAccount],
    }));
  };

  return (
    <Tooltip title={resolvedTooltip}>
      <span>
        <Button size="small" variant="contained" loading={isPulling} onClick={handleClick} disabled={isDisabled}>
          Generate report
        </Button>
      </span>
    </Tooltip>
  );
};
